module.exports = __webpack_public_path__ + "static/media/sign_up.b27e0ee7.png";